'use strict';

const i18n = require('i18next');
const $ = require('jquery');
const _ = require('underscore');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const BlobAPIFactory = require('common/infra/api/blob-factory');
const TypeaheadView = require('common/ui/view/typeahead');
const imageHelper = require('common/ui/template/helper/image');
const ProjectMemberSearchView = require('common/ui/view/project/member-search');
const ElementAction = require('system/domain/action/element');
const DiagramRepository = require('system/domain/repository/diagram');
const ElementRepository = require('system/domain/repository/element');
const TagRepository = require('system/domain/repository/tag');
const Diagrams = require('system/domain/value/diagrams');
const NodeModel = require('system/domain/entity/node');
const SyncStatesModel = require('system/domain/entity/sync-states');
const TagListView = require('system/ui/view/detail/tag-list');
const TagSearchView = require('system/ui/view/detail/tag-search');
const OwnerListView = require('system/ui/view/detail/owner-list');
//依存関係的にこのモジュールから balus を参照するのは NG だが、実装速度を優先して一旦無視する
const ImageSelectorView = require('balus/ui/view/modal/data-content-selector');
//依存関係的にこのモジュールから balus を参照するのは NG だが、実装速度を優先して一旦無視する
const NodeContentAllocationCreateService = require('balus/app/service/allocation/node-content/create');
const LinkedNodeListView = require('system/ui/view/detail/linked-node-list');
const RemoteLinkListView = require('system/ui/view/detail/remote-link-list');
const ValuePropertyListView = require('system/ui/view/detail/value-property-list');
const ValueTypeSearchView = require('system/ui/view/detail/value-type-search');
const NodeDeleteModalView = require('system/ui/view/modal/node-delete');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const SyncStateView = require('system/ui/view/sync-state');
const Template = require('system/ui/template/detail/node-edit.hbs');
const SearchboxItemTemplate = require('system/ui/template/detail/searchbox-dropdown-item.hbs');
const ElementCommunication = require('./element-communication');
const Util = require('common/util');
const Route = require('common/route');
require('backbone.stickit');

const RemoteLinkCreateView = TypeaheadView.extend({
    childViewOptions: function() {
        return {
            context: this._context
        }
    },

    initialize: function(params) {
        params.find = this.find;
        params.update = this.update;
        params.itemView = this.itemView;
        RemoteLinkCreateView.__super__.initialize.call(
            this, params);
        this._source = params.source;
        this._diagram = params.diagram;
        this._context = params.context;
    },

    find: function(query) {
        const diagram = this._diagram;
        const deferred = $.Deferred();

        const path = Route.urlFor('api:project:search',
            this._diagram.idParams());
        $.ajax({
            url: `${path}?query=Record:name=${query}`,
            dataType: 'json'
        })
            .done(function(data) {
                deferred.resolve(
                    _.chain(data['Record'])
                        .map(function(d){
                            return new NodeModel(d);
                        })
                        .filter(function(n) {
                            return !diagram.hasElement(n);
                        })
                        .value()
                );
            });
        return deferred.done;
    },

    update: function(node) {
        ElementAction.createRemoteNode({
            context: this._context,
            node: node.toJSON()
        });
        ElementAction.createRemoteLink({
            context: this._context,
            link: {
                type: 'trace',
                id: Util.generateId(),
                source: this._source.id,
                target: node.id,
                remote: true
            }
        });
        return '';
    },

    enter: function(query) {
        return query;
    },

    itemView: TypeaheadView.DropdownItemView.extend({
        template: SearchboxItemTemplate,
        render: function() {
            const model = this.model;
            const j = model.toJSON();
            j.diagrams = DiagramRepository.getDiagrams({
                context: this.getOption('context')
            })
                .chain()
                .filter(function(d) {
                    return d.hasElement(model);
                })
                .map(function(d){
                    return d.toJSON();
                })
                .value();
            this.$el.html(this.template(j));
            return this;
        }
    })
});

const NodeEditView = Mn.View.extend({
    model: NodeModel,
    template: Template,
    className: 'node-edit',

    ui: {
        image: '.detail-image',
        deleteImage: '.detail-image-delete',
        addRemoteLink: '.add-remote-link',
        name: '.name input',
        width: '.width input',
        height: '.height input'
    },
    regions: {
        description: '.description',
        values: '.values .detail-item-content',
        tag: '.tag .detail-item-content',
        owner: '.owner .detail-item-content',
        ownerSearch: '.owner .owner-search',
        linkedNodes: '.linked-nodes',
        remoteLinks: '.remote-links',
        syncState: '.sync-states',
        imageSelector: '.detail-image',
        nav: '.nav',
        navContent: '.nav-content'
    },
    events: {
        'click .add-comment': 'addComment',
        'click .filter-comment': 'filterComment',
        'click .cancel-edit': 'cancelEdit',
        'click .node-menu-change-type': 'changeType',
        'click .zone-to-node': 'toNode',
        'click .node-to-zone': 'toZone',
        'click .node-menu-delete': 'delete',
        'click .move-to': 'moveTo',
        'click .close-pane': function(){this.trigger('hide')},
        'click @ui.deleteImage': 'deleteImage',
        'input @ui.name': 'name',
        'input @ui.width': 'width',
        'input @ui.height': 'height',
        'click @ui.image': 'showImageSelector'
    },

    initialize: function(params) {
        _.bindAll(this, 'setImage', 'deleteImage', 'save');

        this._diagram = params.diagram;
        this._context = params.context;
        this._channel = this.getOption('channel');

        this.meta = this._diagram.getNodeMeta(this.model.id);
        this.listenTo(this.model, 'change:edit',
            this.trigger.bind(this, 'change:edit'));
        this.listenTo(this.model, 'change',
            this.changeDeleteImageButton);
        this.listenTo(this.model, 'change', this.setImage);
        this.listenTo(this.model.syncState,
            'change:state', function() {
                if(this.model.syncState.isConflict()) {
                    this.render();
                }
            });
    },

    serializeData: function() {
        const json = this.model.toJSON();
        const links = ElementRepository.getLinks({
            context: this._context
        }).getLinksHasEdgeOf(this.model.id);
        // もし複数のダイアグラムに所属するノードでかつ
        // このダイアグラムに存在しないはずの type であればシンボリックノード
        // なので type 変更を許してはいけない
        const model = this.model;
        const diagram = this._diagram;
        const diagrams = DiagramRepository.getDiagrams({
            context: this._context
        })
            .filter(function(d) {
                return d.hasElement(model);
            });
        let typeChangeable = diagrams.length == 1 || _.contains(
                Diagrams.getNodes(diagram.get('type')),
                this.model.get('type')
            );
        let cancelable = !this.model.get('creating');
        let commentCreatable = !this.model.get('creating');
        let deletable = true;
        // コンフリクトしている場合は色々禁止
        if(this.model.syncState.isConflict()) {
            typeChangeable = false;
            cancelable = false;
            deletable = false;
        }
        json['type'] = this.model.i18nType();
        json['hasLinkedNodes'] = links.length > 0;
        json['typeChangeable'] = typeChangeable;
        json['cancelable'] = cancelable;
        json['commentCreatable'] = commentCreatable;
        json['deletable'] = deletable;
        json['isZone'] = this.meta.get('is_zone');
        json['shape'] = this.meta.get('shape');
        json['isSaved'] = this.model.isSaved();

        const appInfo = this.getOption('appInfo');
        json.isProduction = appInfo.isProduction(this._context.groupId);

        return json;
    },

    onRender: function() {
        const members = this.getOption('group').getMembers();
        const project = this.getOption('project');

        this.$('.id input').click(function(){
            $(this).select();
            return false;
        });

        // description
        this._writer = new MarkdownWriterView({
            project: project,
            markdown: this.model.get('description'),
            placeholder: i18n.t('diagram:model.node.description.placeholder'),
            useDataContentSelector: this.model.isSaved()
        });

        this.listenTo(this._writer, 'change', function(desc){
            this.update({description: desc});
        });
        this.listenTo(this._writer, 'insert', content => {
            (new NodeContentAllocationCreateService(project, this.model, content))
                .create()
        });
        this.showChildView('description', this._writer);

        // values
        const appInfo = this.getOption('appInfo');
        if(!appInfo.isProduction(this._context.groupId)) {
            const valueCollection = new Backbone.Collection(this.model.get('values'));
            const valuePropertyListView = new ValuePropertyListView({
                collection: valueCollection,
                context: this._context,
                edit: true
            });
            this.listenTo(this.model, 'change:values', function() {
                valueCollection.set(this.model.get('values'));
            });
            this.listenTo(valuePropertyListView,
                'childview:change:name', function(data) {
                    const value = valueCollection.get(data.id);
                    value.set({name: data.name}, {silent: true});
                    this.update({values: valueCollection.toJSON()});
                });
            this.listenTo(valuePropertyListView,
                'childview:change:unit', function(data) {
                    const value = valueCollection.get(data.id);
                    value.set({unit: data.unit}, {silent: true});
                    this.update({values: valueCollection.toJSON()});
                });
            this.listenTo(valuePropertyListView,
                'childview:change:value', function(data) {
                    const value = valueCollection.get(data.id);
                    data = data.data;
                    const d = value.get('data');
                    if(d) {
                        data = _.extend(d, data);
                    }
                    _.each(data, function(v, k) {
                        if(_.isNull(v.initial)) {
                            delete v.initial;
                        }
                    });
                    value.set({data: data}, {silent: true});
                    this.update({values: valueCollection.toJSON()});
                });
            this.listenTo(valuePropertyListView,
                'childview:delete', function(data) {
                    valueCollection.remove(data.id);
                    this.update({values: valueCollection.toJSON()});
                });
            this.showChildView('values', valuePropertyListView);
            const addValue = _.bind(function(valueType) {
                const valueTypes = ElementRepository.getValueTypes({context: this._context});
                // まだ fetch されていない type が混ざっているかもしれない
                const unfetchedTypes = _.chain(valueType.get('values'))
                    .map(function(v) {return v.type})
                    .filter(function(type) {return !valueTypes.get(type)})
                    .value();
                let deferred = $.Deferred();
                if(unfetchedTypes.length > 0) {
                    deferred = ElementAction.fetchValueTypes({
                        context: this._context,
                        types: unfetchedTypes
                    });
                } else {
                    deferred.resolve();
                }
                deferred.done(_.bind(function() {
                    let values = this.model.get('values');
                    if(!values) {
                        values = [];
                    }
                    values.push({
                        id: Util.generateId(),
                        type: valueType.id
                    });
                    this.update({values: values});
                    this.model.trigger('change:values');
                }, this));
            }, this);
            (new ValueTypeSearchView({
                el: this.$('input.add-value-type'),
                context: this._context,
                onSelect: addValue
            })).render();
        }

        // tag
        const tagCollection = new Backbone.Collection(
            TagRepository.getTags({
                context: this._context
            }).getByIds(this.model.get('tags'))
        );
        this.listenTo(this.model, 'change:tags', function() {
            tagCollection.set(TagRepository.getTags({
                context: this._context
            }).getByIds(this.model.get('tags')), {silent: true});
            tagCollection.trigger('reset');
        });
        const tagListView = new TagListView({
            collection: tagCollection,
            context: this._context,
            edit: true
        });
        tagListView.on('remove:tag', _.bind(function(tag) {
            ElementAction.removeTagFromNode({
                context: this._context,
                tag: {id: tag.id},
                node: {id: this.model.id}
            });
        }, this));

        this.showChildView('tag', tagListView);

        const addTag = _.bind(function(tag) {
            ElementAction.addTagToNode({
                context: this._context,
                tag: {id: tag.id},
                node: {id: this.model.id}
            });
        }, this);
        (new TagSearchView({
            el: this.$('input.add-tag'),
            context: this._context,
            onSelect: addTag,
            onCreate: addTag
        })).render();

        // owner
        const ownerCollection = new Backbone.Collection(
            members.getMembersByUserId(this.model.get('owners'))
        );
        this.listenTo(this.model, 'change:owners', function() {
            ownerCollection.set(
                members.getMembersByUserId(this.model.get('owners')))
        });
        const ownerListView = new OwnerListView({
            collection: ownerCollection,
            members: members,
            context: this._context,
            edit: true
        });
        ownerListView.on('remove:owner', _.bind(function(owner) {
            ElementAction.removeOwnerFromNode({
                context: this._context,
                user: {id: owner.id.toString()},
                node: {id: this.model.id}
            });
        }, this));

        this.showChildView('owner', ownerListView);

        this.showChildView('ownerSearch', new ProjectMemberSearchView({
            project: project
        }));
        this.getChildView('ownerSearch').on('select', member => {
            ElementAction.addOwnerToNode({
                context: this._context,
                user: {id: member.getUser().id.toString()},
                node: {id: this.model.id}
            });
        });

        // linked nodes
        // const links = ElementRepository.getLinks({
        //     context: this._context
        // })
        //     .chain()
        //     .filter(function(link) {
        //         return !link.get('deleted');
        //     })
        //     .filter(function(link) {
        //         return this._diagram.hasLink(link);
        //     }, this)
        //     .value();
        // this.showChildView('linkedNodes', new LinkedNodeListView({
        //     links: links,
        //     node: this.model,
        //     channel: this._channel,
        //     diagram: this._diagram
        // }));

        // remote link
        // this.showChildView('remoteLinks', new RemoteLinkListView({
        //     node: this.model,
        //     edit: true,
        //     diagram: this._diagram,
        //     context: this._context
        // }));

        // sync state
        const syncStateView = new SyncStateView({
            model: new SyncStatesModel({
                models: [
                    this.model.syncState,
                    this._diagram.getNodeMeta(
                        this.model.id).syncState
                ]
            })
        });
        syncStateView.on('sync:start', this.save);
        this.listenTo(syncStateView, 'resync:start', function(){
            ElementAction.resyncNode({
                context: this._context,
                node: {id: this.model.id}
            })
        });
        this.showChildView('syncState', syncStateView);

        // remote link 作成
        // new RemoteLinkCreateView({
        //     minLength: 1,
        //     el: this.ui.addRemoteLink,
        //     source: this.model,
        //     diagram: this._diagram,
        //     context: this._context
        // });

        // image を選択できるようにする
        this.showChildView('imageSelector', new ImageSelectorView({
            project: project,
            accept: ['image']
        }));
        this.listenTo(this.getChildView('imageSelector'), 'select', function(content) {
            const imageURL = content.getLatestVersion().getDataSource().getThumbnailURI();

            (new NodeContentAllocationCreateService(project, this.model, content))
                .create()
                .then(() => {
                    ElementAction.updateNode({
                        context: this._context,
                        node: {
                            id: this.model.id,
                            image_url: imageURL
                        }
                    });
                    this.getChildView('imageSelector').hide();
                })
        });
        this.changeDeleteImageButton();

        this.stickit();

        this.nodeDeleteModal = new NodeDeleteModalView({
            model: this.model,
            context: this._context
        });
        $('#modal-container').append(
            this.nodeDeleteModal.render().el);

        this.showChildView('navContent', new ElementCommunication({
            model: this.model,
            context: this.getOption('newContext'),
            parentContent: this.$('.content'),
            navRegion: this.getRegion('nav')
        }));

        return this;
    },

    onDomRefresh: function() {
        $.material.init();
    },

    onDestroy: function() {
        this.nodeDeleteModal.remove();
    },

    update: function(j) {
        if(this.model.syncState.isConflict()) {
            return;
        }

        j.id = this.model.id;
        ElementAction.updateNode({
            context: this._context,
            node: j
        });
    },

    name: function() {
        this.update({name: this.ui.name.val()});
    },

    changeDeleteImageButton: function() {
        if (this.model.get('image_blob') || this.model.get('image_url')) {
            this.ui.deleteImage.show()
        } else {
            this.ui.deleteImage.hide();
        }
    },

    setImage: function() {
        if(this.ui.image) {
            this.ui.image.attr(
                'src', imageHelper(
                    this.model.get('image_url'), 'small')
            );
        }
    },

    deleteImage: function() {
        this.model.set('image_blob', null);
        this.model.set('image_url', null);
    },

    showImageSelector: function() {
        this.getChildView('imageSelector').show();
    },

    addComment: function() {
        this.trigger('add:comment', this.model);
    },

    filterComment: function() {
        this.trigger('filter:comment',
            this.model.toString({idLength: 10}) + ' ');
    },

    cancelEdit: function() {
        if(this.model.get('creating')) {
            return;
        }
        ElementAction.cancelEditNode({
            context: this._context,
            node: {id: this.model.id}
        });
    },

    changeType: function() {
        this._channel.request('canvas:changeNodeType', this.model);
    },

    save: function() {
        const j = {context: this._context};
        if(this.meta.syncState.isUnsync()) {
            j.metas = {nodes: {}};
            j.metas.nodes[this.model.id] = this.meta.toJSON();
        }
        if(this.model.syncState.isUnsync()) {
            j.models = {
                nodes: [this.model.toJSON()]
            }
        }
        ElementAction.saveElements(j);
    },

    delete: function() {
        this.nodeDeleteModal.show();
    },

    toZone: function() {
        let shape = this.meta.get('shape');
        if(!shape) {
            shape = {
                kind: 'rect',
                attr: {
                    width: 1280,
                    height: 1280
                }
            };
        }
        ElementAction.updateNode({
            context: this._context,
            nodeMeta: {
                id: this.meta.id,
                is_zone: true,
                shape: shape
            }
        });
    },

    toNode: function() {
        ElementAction.updateNode({
            context: this._context,
            nodeMeta: {
                id: this.meta.id,
                is_zone: false
            }
        });
    },

    moveTo: function() {
        this._channel.request('canvas:zoomTo', this.model);
    }
});

module.exports = NodeEditView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/node-edit.js